import React, { Component } from 'react';
import * as Common from './../helpers/Common';
import * as Config from '../config/Config';
import * as User from '../helpers/User';
import Cwsubdetails from './Cwsubdetails';
import MyBookmarks from './MyBookmarks';
import MySearch from './MySearch';

const $= window.$;

class Cwsubject extends Component {
	constructor(props) {
		super(props);
        this.state={



            subject : '',
            component : '',
            sub_id:'',
            mats:[],



        };

         this.setComponentPanel = this.setComponentPanel.bind(this);


	}




	setComponentPanel(type,datas) {
		let pan = '';
		let datas_detail = datas;

		
		let panel = '';
		switch (type) {
        	case 'bookmark':
          		panel= <MyBookmarks handler={this.setComponentPanel}/>
        	break;


        	case 'search':
          		panel= <MySearch searchkey={datas_detail} handler={this.setComponentPanel}/>
        	break;


        	case 'getback':

        		if(datas_detail != undefined){
        			
					 pan = <Cwsubdetails chap_sub={datas_detail}   materials={this.state.mats} handler={this.setComponentPanel}/>
				}
				else{

					 pan = <Cwsubdetails  subject_id={this.state.sub_id} materials={this.state.mats} handler={this.setComponentPanel}/>
				}
          		panel= pan
        	break;


      	}
     	this.setState({
	      component: panel
	    })


	 }

	componentWillReceiveProps(nextProps) {
		if(nextProps.subject_id!=undefined){
			//alert(nextProps.subject_id);
		 	this.setState({
		 		component : <Cwsubdetails subject_id={nextProps.subject_id} materials={nextProps.materials} handler={this.setComponentPanel}/>,
		 		sub_id: nextProps.subject_id,
		 		mats : nextProps.materials
		 	})
		}
	}











		render() {





			return (
				<div>
					<div className="inner-title-bg journey-tit-bg"><h1><span><img src={process.env.PUBLIC_URL+"/images/img-courseware.jpg"} align="absmiddle" alt="" border="0"/></span>
					<span>Courseware</span>
					<br/><span className="subtitle">- subjects and chapters for your study</span></h1></div>
					{this.state.component}
					</div>
			);
		}
}

export default Cwsubject;



// WEBPACK FOOTER //
// ./src/learning_resources/Cwsubject.js